#
<template>
    <div class="calendar calendar--inline">
        <button class="calendar-btn calendar-btn--prev" v-on:click="onCalendarPrev()">-</button>
        <ul>
            <li v-for="calendarDay in calendarDays"
                v-on:click="onClickDate(calendarDay.Date)"
                v-bind:key="calendarDay.Date"
                v-bind:class="getCssClass(calendarDay)">
                <span class="calendar-date">{{formatDate(calendarDay.Date)}}</span>
                <span v-if="calendarDay.IsAvailable" class="calendar-price">&pound;{{priceFormatted(calendarDay.Amount)}}</span>
                <span v-if="!calendarDay.IsAvailable" class="calendar-price">-</span>

            </li>

        </ul>
        <button class="calendar-btn calendar-btn--next"
              
                v-on:click="onCalendarNext()">
            +
        </button>
    </div>


</template>

<script>

    import { store } from '../store/index';

    import moment from 'moment';
    export default {
        name: 'RoomCalendar',
        props: {
            roomType: Object,
            leg: String
        },
        computed: {
            booking() {
                return store.getters.booking;
            },
            session() {
                return store.getters.session;
            },
            search() {
                return store.getters.search;
            },
            isEnabled() {
                return this.leg == '1';
            },
            calendarDays() {
                var roomCode = this.roomType.PMSCode;
                let roomCalendar = store.getters.roomCalendar(roomCode);

                if (roomCalendar != undefined) {
                    return roomCalendar.slice(0, 7);
                }
                return roomCalendar;

            },
            arrivalDate() {
                let result = null;
                if (this.newArrivalDate != null) {
                    var arrivalDate = moment(this.newArrivalDate);
                    result = arrivalDate;
                }
                else {
                    var search = store.getters.search;
                    var arrivalDate = moment(search.arrivalDate);
                    result = arrivalDate
                }

                return moment(moment(result).format("YYYY-MM-DD"));

            },
            seedDate() {
                var search = store.getters.search;
                var date = moment(search.arrivalDate).add(-1, 'd');
                return date;
            },
            departureDate() {
                var result = null;
                if (this.newDepartureDate != null) {
                    let departureDate = moment(this.newDepartureDate);
                    result = departureDate ;
                }
                else {

                    var search = store.getters.search;
                    var arrivalDate = search.arrivalDate;
                    result= moment(arrivalDate).add(+search.numberOfNights, 'd');
                }

                return moment(moment(result).format("YYYY-MM-DD"));


            }
        },
        data() {
            return {
                isOddClick: false,
                newArrivalDate: null,
                newDepartureDate: null
            }
        },
        mounted() {
            var guestQuota = this.search.guestOccupancies[+(this.leg) - 1];
        
            var payload = {
                sessionId: this.session.Id,
                arrivalDate: this.seedDate.format('YYYY-MM-DD'),
                numberOfNights: 7,
                code: this.search.code,
                roomCode: this.roomType.PMSCode,
                rateCode: this.roomType.CalendarDefaultRate,
                guestOccupancies: [guestQuota],
                leg: this.leg,
                voucherCodes: this.search.voucherCodes
            };


            store.dispatch('fetchCalendar', payload);
        },
        methods: {
            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },
            formatDate: function (date) {
                return moment(date).format("DD/MM/YYYY")
            },
            onCalendarNext: function () {
                var guestQuota = this.search.guestOccupancies[+(this.leg) - 1];

                var minDate = moment.min(this.calendarDays.map(x => moment(x.Date)));
                var arrivalDate = minDate.add(7, 'd');
                var payload = {
                    sessionId: this.session.Id,
                    arrivalDate: arrivalDate.format('YYYY-MM-DD'),
                    numberOfNights: 7,
                    roomCode: this.roomType.PMSCode,
                    rateCode: this.roomType.CalendarDefaultRate,
                    guestOccupancies: [guestQuota],
                    leg: this.leg,
                };

                store.dispatch('fetchCalendar', payload);
            },
            onCalendarPrev: function () {
                var guestQuota = this.search.guestOccupancies[+(this.leg) - 1];

                var minDate = moment.min(this.calendarDays.map(x => moment(x.Date)));
                var arrivalDate = minDate.add(-7, 'd');
          
                var payload = {
                    sessionId: this.session.Id,
                    arrivalDate: arrivalDate.format('YYYY-MM-DD'),
                    numberOfNights: 7,
                    roomCode: this.roomType.PMSCode,
                    rateCode: this.roomType.CalendarDefaultRate,
                    guestOccupancies: [guestQuota],
                    leg: this.leg,
                };

                store.dispatch('fetchCalendar', payload);
            },
            getCssClass: function (calDay) {
                let thisDate = moment(calDay.Date);


                let result = '';

                if (!this.isEnabled) {
                    result += 'disabled ';
                }

                if (calDay.IsClosed) {
                    result += 'unavailable ';
                }
               
                if (thisDate.isBetween(this.arrivalDate, this.departureDate)
                    || thisDate.isSame(this.arrivalDate)) {
                    result += 'stay ';
                }
                if (thisDate.isSame(this.departureDate)) {
                    result += 'checkout ';
                }

                return result;

            },
            onClickDate: function (date) {
                if (!this.isEnabled) {
                    return;
                }
                this.isOddClick = !this.isOddClick;

                var thisDate = moment(date);
                var formatted = thisDate.format('YYYY-MM-DD');

                if (this.isOddClick) {
                    this.newArrivalDate = formatted;
                    this.newDepartureDate = formatted;

                }
                else {

                    if (this.arrivalDate.isAfter(thisDate)) {
                        let perviousArrivalFormatted = this.newArrivalDate;
                        this.newArrivalDate = formatted;
                        this.newDepartureDate = perviousArrivalFormatted;


                    } else {
                        this.newDepartureDate = formatted
                    }


                    let existingSearch = this.search;

                    var mArrivalDate = moment(this.newArrivalDate);
                    var mDepartureDate = moment(this.newDepartureDate);
                    var days = mDepartureDate.diff(mArrivalDate, 'days');


                    var search = {
                        sessionId: existingSearch.sessionId,
                        guestOccupancies: existingSearch.guestOccupancies,
                        code: existingSearch.code,
                        arrivalDate: this.newArrivalDate,
                        numberOfNights: days,
                    };

                    let bookingPayload = {
                        monetaryVouchers: this.booking.vouchers
                    };

                    store.dispatch("clearPartialData").then(() => {
                        store.dispatch('setSearch', search).then(() => {


                            store.dispatch('createBooking', bookingPayload);
                            store.dispatch('searchRooms', this.search);
                        })
                    });

                }


            }
        },
       
    }



</script>

